const PromotionPinSvg = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" fill="none">
            <path fill="#546EDB" d="M8 .382A8.004 8.004 0 0 0 .609 5.317a7.99 7.99 0 0 0 1.734 8.713A8.002 8.002 0 0 0 16 8.377c0-2.12-.843-4.154-2.343-5.653A8.003 8.003 0 0 0 8 .382Zm3.114 6.344L9.386 8.454c.346.658.472 1.409.36 2.143-.111.735-.694 2.072-.98 1.94-.288-.131-2.106-2.104-2.106-2.104L4.421 12.67l-.947.231.231-.946 2.24-2.236S3.972 7.96 3.838 7.614c-.134-.346 1.206-.869 1.941-.98a3.49 3.49 0 0 1 2.145.36l1.727-1.729c-.244-.665-.148-1.367.315-1.832.463-.465 3.533 2.445 2.98 2.98-.552.536-1.168.556-1.833.313Z"/>
        </svg>
    )
}

export default PromotionPinSvg;